import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import { pluralize } from "core/strings";

import Icon from "ui/atom/Icon";
import Box from "ui/atom/Box";
import Button from "ui/base/Button";

import { useStart } from "features/start/fabric";
import { useContentUnlock } from "areas/unlock/fabric";


export default function Wallet () {
	const content = useContentUnlock();
	const start = useStart();
	const theme = useTheme();

	const profile = start.profile;
	const color = content.insufficient ? "error" : "coin";

	const style = {
		root: { width: "100%" },
		wallet: {
			width: "100%",
			justifyContent: "space-between", alignItems: "center",
			pl: theme.spacing(2),
			borderRadius: "16px",
			border: "1px solid",
			borderColor: theme.palette[color]?.main
		},
		content: { alignItems: "center" },
		text: { alignItems: "center" },
		insufficient: { textAlign: "center" }
	};

	return (
		<Box.Column gap={1} sx={style.root}>
			{content.insufficient && <Typography variant="h4" color="error.main" sx={style.insufficient}>You have insufficient tokens!</Typography>}
			<Box sx={style.wallet}>
				<Box gap={1.25} sx={style.content}>
					<Icon name="wallet" size={18} />
					<Box gap={0.625} sx={style.text}>
						<Typography variant="body4">You have</Typography>
						<Icon.Coin size={9} />
						<Typography variant="caption" color={color}>
							{pluralize(profile?.balance, "Subly token")}
						</Typography>
					</Box>
				</Box>
				<Button color={color} size="small" onClick={content.getMore}>Get more</Button>
			</Box>
		</Box.Column>
	);
};